import { Text } from "@chakra-ui/react";
import { useMemo } from "react";

const URL_SPLIT_REGEX = /(https?:\/\/\S+)/g;
const URL_TEST_REGEX = /^https?:\/\//;

interface NoteWithLinksProps {
  note: string;
  onLinkClick?: (url: string) => void;
}

export const NoteWithLinks = ({ note, onLinkClick }: NoteWithLinksProps) => {
  const parts = useMemo(() => note.split(URL_SPLIT_REGEX), [note]);

  const handleLinkClick = (e: React.MouseEvent, url: string) => {
    e.preventDefault();
    e.stopPropagation();
    onLinkClick?.(url);
  };

  return (
    <Text maxW="400px">
      {parts.map((part) =>
        URL_TEST_REGEX.test(part) ? (
          <Text
            key={`note-link-part-${part}`}
            as="span"
            color="teal.500"
            textDecoration="underline"
            cursor="pointer"
            onClick={(e) => handleLinkClick(e, part)}
          >
            {part}
          </Text>
        ) : (
          <span key={`note-link-part-${part}`}>{part}</span>
        ),
      )}
    </Text>
  );
};
